<template>
  <v-card class="rsl-fixed-height">
    <v-btn
      small
      class="mr-2 ma-3"
      color="success"
      @click="saveTemplate()"
    >{{ $t('TEMPLATES.BTNS.SAVE') }}</v-btn>
    <v-btn
      small
      class="mr-2 ma-3"
      color="secondary"
      @click="closeEditor()"
    >{{ $t('TEMPLATES.BTNS.CLOSE') }}</v-btn>

      <v-row class="pa-3">
        <v-col v-if="templateAction == 'edit'" sm="12" md="12">
          {{ $t('TEMPLATES.EDIT_TEMPLATE.DESC') }}: <b>{{ templateName }}</b> ({{ editType }})
        </v-col>
        <v-col sm="12" md="12">
          <editor v-model="content" :init="init"></editor>
        </v-col>
      </v-row>


    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="saveDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ saveTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ saveText }}</div>
            <v-form v-model="isFormValid">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="tempName"
                    :label="$t('TEMPLATES.FIELDS.NAME')"
                    :rules="[rules.required]"
                  >{{ tempName }}</v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="saveDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="confirmSave()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

  </v-card>
</template>

<script>
  import Editor from '@tinymce/tinymce-vue'
  import 'tinymce/tinymce'
  // Theme
  import 'tinymce/themes/silver'
  // Skins
  import '../assets/tinymce/skins/ui/oxide/skin.min.css'
  import '../assets/tinymce/skins/ui/oxide/content.css'
  import '../assets/tinymce/skins/content/default/content.min.css'
  // Plugins
  import 'tinymce/plugins/advlist'
  import 'tinymce/plugins/autolink'
  import 'tinymce/plugins/lists'
  import 'tinymce/plugins/link'
  import 'tinymce/plugins/image'
  import 'tinymce/plugins/charmap'
  import 'tinymce/plugins/preview'
  import 'tinymce/plugins/anchor'
  import 'tinymce/plugins/searchreplace'
  import 'tinymce/plugins/visualblocks'
  import 'tinymce/plugins/code'
  import 'tinymce/plugins/fullscreen'
  import 'tinymce/plugins/insertdatetime'
  import 'tinymce/plugins/media'
  import 'tinymce/plugins/table'
  import 'tinymce/plugins/help'
  import 'tinymce/plugins/wordcount'
  // Icons
  import 'tinymce/icons/default'
  // Models
  import 'tinymce/models/dom'

  import { mapGetters } from 'vuex';

  export default {
    name: 'templateeditor',
    components: {
      'editor': Editor
    },
    computed: {
      ...mapGetters(['templateId', 'templateKey', 'templateName', 'templateType', 'templateAction', 'templateData', 'imageDataSaved']),
    },
    data: function() {
      return {
        content: null,
        init: {
          skin: false,
          content_css: false,
          height: 500,
          font_family_formats: 'Andale Mono=andale mono, monospace; Arial=arial, helvetica, sans-serif; Arial Black (DOCX only)=arial black, arial, sans-serif; Book Antiqua=book antiqua, palatino, serif; Comic Sans MS (DOCX only)=comic sans ms, sans-serif; Courier New=courier new, courier, monospace; Georgia=georgia, palatino, serif; Helvetica=helvetica, arial, sans-serif; Impact (DOCX only)=impact, sans-serif; Symbol (DOCX only)=symbol; Tahoma=tahoma, arial, helvetica, sans-serif; Terminal=terminal, monaco, monospace; Times New Roman=times new roman, times, serif; Trebuchet MS (DOCX only)=trebuchet ms, geneva, sans-serif; Verdana (DOCX only)=verdana, geneva, sans-serif;',
          plugins: [ 'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor',
           'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'wordcount'
          ],
          toolbar: 'undo redo | blocks | fontfamily | fontsize | bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | table | link unlink | image insertfile | code | language',
          content_langs: [
            { title: 'English', code: 'en' },
            { title: 'French', code: 'fr' },
            { title: 'German', code: 'de' },
            { title: 'Polish', code: 'pl' },
            { title: 'Portuguese', code: 'pt' },
            { title: 'Spanish', code: 'es' }
          ],
          menubar: false,
          convert_urls: false,
          images_upload_handler: this.handleImageAdded,
          setup : function(ed)
            {
                ed.on('init', function() 
                {
                    this.getDoc().body.style.fontSize = '12';
                    this.getDoc().body.style.fontFamily = 'Arial';
                });
            },
        },
        editType: '',
        tempName: null,
        saveDialog: false,
        saveTitle: '',
        saveText: '',
        isFormValid: false,
        rules: {
          required: value => !!value || 'Required'
        },
      }
    },
    async created() {

      setTimeout(function(){ 
        const el = document.getElementsByClassName("tox-statusbar__branding")[0];
        el.remove();
      }, 50);

      if(this.templateAction == 'edit') {
        await this.$store.dispatch('getTemplateData', this.templateKey).then( () => {
          // Edit template
          this.content = this.templateData;
        });

        if(this.templateType == 'document') {
          this.editType = this.$t('TEMPLATES.EDIT_TEMPLATE.TYPE_DOC');
        }else {
          this.editType = this.$t('TEMPLATES.EDIT_TEMPLATE.TYPE_EMAIL');
        }
      }

    },
    methods: {
      saveTemplate() {
        this.saveTitle = this.$t('TEMPLATES.SAVE_TEMPLATE.TITLE');
        
        if(this.templateAction == 'edit') {
          this.saveText = this.$t('TEMPLATES.SAVE_TEMPLATE.DESC_EDIT');
          this.tempName = this.templateName;
        }else {
          this.saveText = this.$t('TEMPLATES.SAVE_TEMPLATE.DESC_NEW');
        }

        this.saveDialog = true;
      },
      async confirmSave() {
        this.saveDialog = false;

        // Set the template key based off the title
        let templateKey = this.tempName.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, ''); // Remove specials
        templateKey = templateKey.replace(/\s/g, ''); // Remove spaces
        
        let html = "<html lang='en'>" +
                      "<head>" +
                      "</head>" +
                      "<body>" +
                        this.content +
                      "</body>" +
                    "</html>";
        
        let payload = {
          'name': this.tempName,
          'key': templateKey,
          'type': this.templateType,
          'data': html
        };
        
        if(this.templateAction == 'edit') {
          payload['id'] = this.templateId
        }else {
          payload['id'] = 0;
        }
        
        this.$store.dispatch('saveTemplate', payload).then( () => {
          let tempType = '';
          if(this.templateType == 'document') {
            tempType = 'Document';
          }
          if(this.templateType == 'email') {
            tempType = 'Email';
          }
          if(this.templateAction == 'edit') {
            this.updateLog('Template', 'Updated', tempType + ' template ' + this.tempName + ' updated.');
          }else {
            this.updateLog('Template', 'Created', tempType + ' template ' + this.tempName + ' created.');
          }

          this.$router.push({ name: 'Templates' });
        });
      },
      closeEditor() {
        this.$router.push({ name: 'Templates' });
      },
      generateRandomId() {
        // Declare all characters
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let length = 34;

        // Generate ID
        let str = '';
        for (let i = 0; i < length; i++) {
            str += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return str;
      },
      handleImageAdded(blobInfo) {
        let id = this.generateRandomId();

        let fileName = blobInfo.filename();
        let mimeType = blobInfo.blob().type;
        let fileSize = blobInfo.blob().size;

        let payload = {
          'id': id,
          'name': fileName,
          'mimeType': mimeType,
          'size': fileSize,
          'created': new Date(),
          'fileData': blobInfo.base64()
        }

        let promise = new Promise((resolve, reject) => {
          this.$store.dispatch('uploadImageData', payload).then( async result => {
            await result;
            if(result) {
              let engineUrl = this.$store.state.engineUrl;
              engineUrl = engineUrl.replace('engine-rest', 'images/');
              let url = engineUrl + fileName;
              resolve(url);
            }else {
              reject('Failed to save image.', { remove: true });
            }
          });
        });
        return promise;
      },
      updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>
